<template>
  <InputLabel
    :label="label"
    :name="name"
  />
  <input
    v-model="valueProxy"
    v-maska="mask"
    class="w-full bg-gray-100 leading-10 px-3 border-b-4"
    :class="{ 'bg-red-100 border-red-200': errorMessages.length > 0 }"
    :name="name"
    :type="type"
  >
  <div
    v-if="errorMessages.length > 0"
    class="text-sm text-red-400 pt-2"
  >
    {{ errorMessages[0] }}
  </div>
</template>

<script>
import createProxy from '../../../helpers/createProxy';
import InputLabel from './InputLabel.vue';

export default {
  name: 'TextInput',

  components: {
    InputLabel,
  },

  props: {
    errorMessages: {
      default: () => [],
      type: Array,
    },
    label: {
      required: true,
      type: String,
    },
    mask: {
      default: null,
      type: [
        Object,
        String,
      ],
    },
    name: {
      required: true,
      type: String,
    },
    type: {
      required: false,
      default: 'text',
      type: String,
    },
    value: {
      default: null,
      type: String,
    },
  },

  computed: {
    /** @type {boolean} */
    valueProxy: createProxy('value'),
  },
};
</script>
